// sort-imports-ignore
// Native Intl must be initialized before Lingui and its message catalogs.
import "./intlPolyfills";
import { i18n } from "@lingui/core";

import { messages as englishMessages } from "./../../../locales/en/messages.js";
import { messages as frenchMessages } from "./../../../locales/fr/messages.js";

i18n.load({ en: englishMessages, fr: frenchMessages });
i18n.activate("en");

export { i18n };
